module.exports = __webpack_public_path__ + "img/个性化.90cc1ba0.svg";